import Vue from "vue";

const state = {
	filterBy: null,
	sortBy: false,
	type: null
};
const getters = {
	filterby: (state) => state.filterBy,
	sortby: (state) => state.sortBy
};
const actions = {
	setFilterBy({ commit }, text) {
		commit("SET_FILTERBY", text);
	}
};
const mutations = {
	SET_FILTERBY(state, text) {
		state.filterBy = text;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
